<template>
  <a-list>
    <a-list-item> </a-list-item>
  </a-list>
</template>

<script>
export default {
  name: 'Project'
}
</script>

<style scoped></style>
